module.exports = __webpack_public_path__ + "img/certification-institutions.5f634a9d.png";